import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ToolboxService } from './config/toolBox.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InteriorObject } from '../models/interior-object.model';
import { LayerComponent } from '../models/components/commonComponents/LayerComponent';
import { RequestService } from '../services/request.service';
import { ComponentNames } from '../helper/componentNames';

@Component({
  selector: 'app-toolbox',
  templateUrl: './toolbox.component.html',
  styleUrls: ['./toolbox.component.scss']
})
export class ToolboxComponent implements OnInit, OnDestroy {
  private destroyed$: Subject<void> = new Subject();
  hideDeselectButton: boolean;
  source: Array<InteriorObject>;
  private currentToolBoxItem: InteriorObject;
  // if ToolBoxItem includes this number in availableLayers than its available for those
  private currentLayer: number = 1;
  @Input('Config') config: ToolboxService;

  constructor(private resourceService: RequestService) {
    this.hideDeselectButton = true;
  }

  ngOnInit() {
    this.config.sourceHttpCall(this.resourceService).pipe(takeUntil(this.destroyed$)).subscribe(
      (resp: InteriorObject[]) => {
        this.source = [];
        // since the response remains a JSON Object we need to loop over it and map each element to the desired typed object
        for (let index = 0; index < resp.length; index++) {
          const element = resp[index];
          // map JSON object to Interior object otherwise methods from InteriorObject won't be available in here
          this.source.push(Object.assign(new InteriorObject(), element));
        }
      }
    );

    this.hideDeselectButton = this.config.hideDeselectButton;
    this.config.currentItem.pipe(takeUntil(this.destroyed$)).subscribe((value: InteriorObject) => {
      this.currentToolBoxItem = value;
    });
    
    this.config.currentLayer.pipe(takeUntil(this.destroyed$)).subscribe((value: number) => {
      this.currentLayer = value;
    });
  }

  toggleItem(item: InteriorObject) {
    this.currentToolBoxItem = item;
    this.config.currentItem.next(this.currentToolBoxItem);
  }

  private getClassByActivity(item: InteriorObject) {
    // @ts-ignore
    if (item === this.currentToolBoxItem) {
      return 'sidepanel-toolbox-button active';
    } else {
      return 'sidepanel-toolbox-button';
    }
  }

  getImageComponent(item: InteriorObject) {
    return item.getComponent(ComponentNames.imageComponent);
  }

  isDisabled(item: InteriorObject) {
    const layer = item.getComponent<LayerComponent>(ComponentNames.layerComponent);
    if (layer == null)
      return false;
    return this.config.listenToLayer ? this.currentLayer !== layer.id : false;
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}